import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { TitleState} from '../model/BoardSearch'

//* 초기 상태
const initialState: TitleState = {
    name:''
};

const title = createSlice({
    name: 'board',
    initialState,
    reducers: {
        setModel(state, action: PayloadAction<TitleState>) {
            state = {
                ...state,
                name: action.payload.name
            };
            return state;
        },
        //* 초기화 하기
        init(state) {
            state = initialState;
            return state;
        }
    }
});

export const titleActions = {...title.actions};

export default title;
